import { render, staticRenderFns } from "./documentos-da-origem.vue?vue&type=template&id=40fbfcbe&scoped=true"
import script from "./documentos-da-origem.vue?vue&type=script&lang=js"
export * from "./documentos-da-origem.vue?vue&type=script&lang=js"
import style0 from "./documentos-da-origem.vue?vue&type=style&index=0&id=40fbfcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fbfcbe",
  null
  
)

export default component.exports